import { render, staticRenderFns } from "./LocationListAddNew.vue?vue&type=template&id=0fc43938"
import script from "./LocationListAddNew.vue?vue&type=script&lang=js"
export * from "./LocationListAddNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports